import { useForm } from '@inertiajs/react'
import { Shield } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface Props {
  phone: string
  error?: string
  flash?: { notice?: string }
}

export default function VerifyOTP({ phone, error, flash }: Props) {
  const { data, setData, post, processing } = useForm({
    code: '',
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post('/admin/login/verify')
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Shield className="h-6 w-6" />
          </div>
          <CardTitle className="text-xl">Verificar código</CardTitle>
          <p className="text-sm text-muted-foreground">
            Enviamos un código a {phone}
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="code">Código</Label>
              <Input
                id="code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                placeholder="000000"
                value={data.code}
                onChange={(e) => setData('code', e.target.value)}
                autoFocus
                className="text-center text-lg tracking-widest"
              />
            </div>

            {flash?.notice && (
              <p className="text-sm text-muted-foreground">{flash.notice}</p>
            )}

            {error && (
              <p className="text-sm text-destructive">{error}</p>
            )}

            <Button type="submit" className="w-full" disabled={processing || data.code.length < 6}>
              {processing ? 'Verificando...' : 'Verificar'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
